// import React from "react";
// import { FiClock, FiUsers, FiMapPin, FiAward } from "react-icons/fi";

// export default function AaryanStats() {
//   const stats = [
//     {
//       icon: <FiClock className="stats-icon" />,
//       number: "24*7",
//       label: "Hours of Service"
//     },
//     {
//       icon: <FiUsers className="stats-icon" />,
//       number: "500+",
//       label: "Corporate Clients"
//     },
//     {
//       icon: <FiMapPin className="stats-icon" />,
//       number: "180+",
//       label: "Cities Covered"
//     },
//     {
//       icon: <FiAward className="stats-icon" />,
//       number: "13+",
//       label: "Years Experience"
//     }
//   ];

//   return (
//     <section className="aaryan-stats">
//       <div className="stats-container">
//         {stats.map((item, index) => (
//           <div key={index} className="stats-card">
//             {item.icon}
//             <h3 className="stats-number">{item.number}</h3>
//             <p className="stats-label">{item.label}</p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// // }

// import React, { useEffect, useRef, useState } from "react";
// import { FiClock, FiUsers, FiMapPin, FiAward } from "react-icons/fi";

// /* ===== COUNTER COMPONENT ===== */
// const Counter = ({ end, suffix = "" }) => {
//   const [count, setCount] = useState(0);
//   const ref = useRef(null);

//   useEffect(() => {
//     let start = 0;
//     const duration = 2000;
//     const stepTime = 20;
//     const totalSteps = duration / stepTime;
//     const increment = end / totalSteps;

//     const timer = setInterval(() => {
//       start += increment;

//       if (start >= end) {
//         setCount(end);
//         clearInterval(timer);
//       } else {
//         setCount(Math.ceil(start));
//       }
//     }, stepTime);

//     return () => clearInterval(timer);
//   }, [end]);

//   return (
//     <h3 ref={ref} className="stats-number">
//       {count}
//       {suffix}
//     </h3>
//   );
// };

// /* ===== MAIN STATS ===== */
// export default function AaryanStats() {
//   const stats = [
//     {
//       icon: <FiClock className="stats-icon" />,
//       label: "Hours of Service",
//       text: "24×7"
//     },
//     {
//       icon: <FiUsers className="stats-icon" />,
//       label: "Corporate Clients",
//       number: 500,
//       suffix: "+"
//     },
//     {
//       icon: <FiMapPin className="stats-icon" />,
//       label: "Cities Covered",
//       number: 180,
//       suffix: "+"
//     },
//     {
//       icon: <FiAward className="stats-icon" />,
//       label: "Years Experience",
//       number: 13,
//       suffix: "+"
//     }
//   ];

//   return (
//     <section className="aaryan-stats">
//       <div className="stats-container">
//         {stats.map((item, index) => (
//           <div className="stats-card" key={index}>
//             {item.icon}

//             {item.number ? (
//               <Counter end={item.number} suffix={item.suffix} />
//             ) : (
//               <h3 className="stats-number">{item.text}</h3>
//             )}

//             <p className="stats-label">{item.label}</p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }










import React, { useEffect, useRef, useState } from "react";
import { FiClock, FiUsers, FiMapPin, FiAward } from "react-icons/fi";

/* ================= COUNTER ================= */
const Counter = ({ end, suffix = "" }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  /* 👁️ OBSERVE WHEN ELEMENT ENTERS / LEAVES SCREEN */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
          setCount(0); // reset when out of view
        }
      },
      { threshold: 0.4 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  /* 🔢 COUNT ANIMATION */
  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const duration = 2000; // 2 seconds
    const stepTime = 20;
    const totalSteps = duration / stepTime;
    const increment = end / totalSteps;

    const timer = setInterval(() => {
      start += increment;

      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.ceil(start));
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [isVisible, end]);

  return (
    <h3 ref={ref} className="stats-number">
      {count}
      {suffix}
    </h3>
  );
};

/* ================= MAIN STATS ================= */
export default function AaryanStats() {
  const stats = [
    {
      icon: <FiClock className="stats-icon" />,
      label: "Hours of Service",
      text: "24×7"
    },
    {
      icon: <FiUsers className="stats-icon" />,
      label: "Corporate Clients",
      number: 500,
      suffix: "+"
    },
    {
      icon: <FiMapPin className="stats-icon" />,
      label: "Cities Covered",
      number: 180,
      suffix: "+"
    },
    {
      icon: <FiAward className="stats-icon" />,
      label: "Years Experience",
      number: 13,
      suffix: "+"
    }
  ];

  return (
    <section className="aaryan-stats">
      <div className="stats-container">
        {stats.map((item, index) => (
          <div className="stats-card" key={index}>
            {item.icon}

            {item.number ? (
              <Counter end={item.number} suffix={item.suffix} />
            ) : (
              <h3 className="stats-number">{item.text}</h3>
            )}

            <p className="stats-label">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
